module.exports = __webpack_public_path__ + "img/talron-close.384973b7.svg";